export default __webpack_public_path__ + "static/tablet_KV17-e2535309d772c9599764eadfe16550b8.mp4";